
    <template>
      <section class="relax-doc">
        <h1>Switch 开关</h1>
<blockquote>
<p>开关选择器</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>切换状态时，触发事件</p>
</blockquote>
<demo-block>
        <p>当状态改变时，会触发 <code>change</code> 事件</p>

        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
   &lt;x-switch v-model=&quot;state1&quot;&gt;&lt;/x-switch&gt;
   &lt;x-switch v-model=&quot;state2&quot; @change=&quot;change&quot;&gt;&lt;/x-switch&gt; 
&lt;/template&gt;

&lt;script&gt;
import {ref, getCurrentInstance} from 'vue'
export default {
  setup(){
    const instance = getCurrentInstance()
    const {$message} = instance.appContext.config.globalProperties

    const state1 = ref(true)
    const state2 = ref(false)

    const change = (status) =&gt; {
      $message.success('switch2状态：' + status)
    }

    return {
      state1,
      state2,
      change
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="wen-zi-he-tu-biao"><a class="header-anchor" href="#wen-zi-he-tu-biao"></a> 文字和图标</h2>
<blockquote>
<p>自定义内容, 建议文字长度保持统一</p>
</blockquote>
<demo-block>
        <p>使用 <code>open</code> 和 <code>close</code> 插槽</p>

        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-switch v-model=&quot;state1&quot;&gt;
    &lt;template #open&gt;开&lt;/template&gt;
    &lt;template #close&gt;关&lt;/template&gt;
  &lt;/x-switch&gt;

  &lt;x-switch v-model=&quot;state2&quot;&gt;
    &lt;template #open&gt;打开&lt;/template&gt;
    &lt;template #close&gt;关闭&lt;/template&gt;
  &lt;/x-switch&gt;

  &lt;x-switch v-model=&quot;state3&quot;&gt;
    &lt;template #open&gt;
      &lt;x-icon type=&quot;x-icon-check&quot;/&gt;
    &lt;/template&gt;
    &lt;template #close&gt;
      &lt;x-icon type=&quot;x-icon-x&quot; /&gt;
    &lt;/template&gt;
  &lt;/x-switch&gt;
&lt;/template&gt;

&lt;script&gt;
import {ref} from 'vue'
export default {
  setup(){
    const state1 = ref(false)
    const state2 = ref(true)
    const state3 = ref(true)

    return {
      state1,
      state2,
      state3
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="bu-tong-se-xi"><a class="header-anchor" href="#bu-tong-se-xi"></a> 不同色系</h2>
<blockquote>
<p>提供了 <code>primary</code> <code>info</code> <code>danger</code> <code>success</code> <code>warning</code> 五种颜色， 默认<code>primary</code></p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-switch v-model=&quot;state1&quot; type=&quot;primary&quot;&gt;&lt;/x-switch&gt;
  &lt;x-switch v-model=&quot;state2&quot; type=&quot;info&quot;&gt;&lt;/x-switch&gt;
  &lt;x-switch v-model=&quot;state3&quot; type=&quot;danger&quot;&gt;&lt;/x-switch&gt;
  &lt;x-switch v-model=&quot;state4&quot; type=&quot;success&quot;&gt;&lt;/x-switch&gt;
  &lt;x-switch v-model=&quot;state5&quot; type=&quot;warning&quot;&gt;&lt;/x-switch&gt;
&lt;/template&gt;

&lt;script&gt;
import {ref} from 'vue'
export default {
  setup(){
    const state1 = ref(true)
    const state2 = ref(true)
    const state3 = ref(true)
    const state4 = ref(true)
    const state5 = ref(true)

    return {
      state1,
      state2,
      state3,
      state4,
      state5,
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="bu-ke-dian-ji"><a class="header-anchor" href="#bu-ke-dian-ji"></a> 不可点击</h2>
<blockquote>
<p>禁止点击状态</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo3 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-switch v-model=&quot;state&quot; :disabled=&quot;disabled&quot;&gt;&lt;/x-switch&gt;
  &lt;x-button @click=&quot;disabled = !disabled&quot;&gt;{{ disabled ? '激活' : '禁止' }}&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
import {ref} from 'vue'
export default {
  setup(){
    const state = ref(true)
    const disabled = ref(true)

    return {
      state,
      disabled
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_switch = _resolveComponent("x-switch")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state1,
      "onUpdate:modelValue": $event => ((_ctx.state1) = $event)
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state2,
      "onUpdate:modelValue": $event => ((_ctx.state2) = $event),
      onChange: _ctx.change
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
  ], 64))
}
  
    
        const {ref, getCurrentInstance} = Vue
        
const democomponentExport = {
  setup(){
    const instance = getCurrentInstance()
    const {$message} = instance.appContext.config.globalProperties

    const state1 = ref(true)
    const state2 = ref(false)

    const change = (status) => {
      $message.success('switch2状态：' + status)
    }

    return {
      state1,
      state2,
      change
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_switch = _resolveComponent("x-switch")
  const _component_x_icon = _resolveComponent("x-icon")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state1,
      "onUpdate:modelValue": $event => ((_ctx.state1) = $event)
    }, {
      open: _withCtx(() => [
        _createTextVNode("开")
      ]),
      close: _withCtx(() => [
        _createTextVNode("关")
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state2,
      "onUpdate:modelValue": $event => ((_ctx.state2) = $event)
    }, {
      open: _withCtx(() => [
        _createTextVNode("打开")
      ]),
      close: _withCtx(() => [
        _createTextVNode("关闭")
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state3,
      "onUpdate:modelValue": $event => ((_ctx.state3) = $event)
    }, {
      open: _withCtx(() => [
        _createVNode(_component_x_icon, { type: "x-icon-check" })
      ]),
      close: _withCtx(() => [
        _createVNode(_component_x_icon, { type: "x-icon-x" })
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"])
  ], 64))
}
  
    
        const {ref} = Vue
        
const democomponentExport = {
  setup(){
    const state1 = ref(false)
    const state2 = ref(true)
    const state3 = ref(true)

    return {
      state1,
      state2,
      state3
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_switch = _resolveComponent("x-switch")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state1,
      "onUpdate:modelValue": $event => ((_ctx.state1) = $event),
      type: "primary"
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state2,
      "onUpdate:modelValue": $event => ((_ctx.state2) = $event),
      type: "info"
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state3,
      "onUpdate:modelValue": $event => ((_ctx.state3) = $event),
      type: "danger"
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state4,
      "onUpdate:modelValue": $event => ((_ctx.state4) = $event),
      type: "success"
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state5,
      "onUpdate:modelValue": $event => ((_ctx.state5) = $event),
      type: "warning"
    }, null, 8, ["modelValue", "onUpdate:modelValue"])
  ], 64))
}
  
    
        const {ref} = Vue
        
const democomponentExport = {
  setup(){
    const state1 = ref(true)
    const state2 = ref(true)
    const state3 = ref(true)
    const state4 = ref(true)
    const state5 = ref(true)

    return {
      state1,
      state2,
      state3,
      state4,
      state5,
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, toDisplayString: _toDisplayString, createTextVNode: _createTextVNode, withCtx: _withCtx, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_switch = _resolveComponent("x-switch")
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_switch, {
      modelValue: _ctx.state,
      "onUpdate:modelValue": $event => ((_ctx.state) = $event),
      disabled: _ctx.disabled
    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
    _createVNode(_component_x_button, {
      onClick: $event => (_ctx.disabled = !_ctx.disabled)
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.disabled ? '激活' : '禁止'), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
}
  
    
        const {ref} = Vue
        
const democomponentExport = {
  setup(){
    const state = ref(true)
    const disabled = ref(true)

    return {
      state,
      disabled
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  